import EmissionPerYear from "../Domain/EmissionPerYear";
import { getEmissionsByUser } from "./Emissions.service";

export async function getEmissionsByUserRepository(years = []) {
  const response = await getEmissionsByUser(years);
  const yearsData = response.data || {};
  return new EmissionPerYear(yearsData);
}
